import Vue from 'vue'
import VueRouter from 'vue-router'

// import StayTuned from '@/pages/StayTuned'
import Landing from '@/pages/Landing'
import About from '@/pages/About'
import Services from '@/pages/Services'
import Links from '@/pages/Links'
import Faq from '@/pages/Faq'
import Reports from '@/pages/reports'
import Payment from '@/pages/payment'
import Contact from '@/pages/contact'
import Survey from '@/pages/survey'
// import Shows from '@/pages/Shows'
// import ShowDetail from '@/pages/ShowDetail'
import NotFound from '@/pages/NotFound'

Vue.use(VueRouter)

var vueRouter = new VueRouter({
  mode: 'history',
  routes: [
    // {
    //   path: '/staytuned',
    //   name: 'staytuned',
    //   id: -1,
    //   title: 'Stay Tuned',
    //   component: StayTuned
    // },
    {
      path: '/',
      name: 'landing',
      id: 0,
      title: 'Landing',
      component: Landing
    },
    {
      path: '/about',
      name: 'about',
      id: 0,
      title: 'About',
      component: About
    },
    {
      path: '/services',
      name: 'services',
      id: 0,
      title: 'Services',
      component: Services
    },
    {
      path: '/links',
      name: 'links',
      id: 0,
      title: 'Links',
      component: Links
    },
    {
      path: '/faq',
      name: 'faq',
      id: 0,
      title: 'Faq',
      component: Faq
    },
    {
      path: '/reports',
      name: 'reports',
      id: 0,
      title: 'Reports',
      component: Reports
    },
    {
      path: '/payment',
      name: 'payment',
      id: 0,
      title: 'Payment',
      component: Payment
    },
    {
      path: '/contact',
      name: 'contact',
      id: 0,
      title: 'Contact',
      component: Contact
    },
    {
      path: '/survey',
      name: 'survey',
      id: 0,
      title: 'Survey',
      component: Survey
    },
    // {
    //   path: '/shows',
    //   name: 'shows',
    //   id: 1,
    //   title: 'Shows',
    //   component: Shows
    // },
    // {
    //   path: '/show-detail',
    //   name: 'show-detail',
    //   id: 2,
    //   title: 'Show Detail',
    //   component: ShowDetail
    // },
    {
      path: '*',
      name: 'notfound',
      id: 404,
      title: 'Not Found',
      component: NotFound
    }
  ]
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js